import { DATE_FORMAT, formatShortISO, parse } from '@eneco/common/date';
import { RequestModels_Products_Offers_V3_OfferProductsPublicV3Request } from '@monorepo-types/dc';

import { FlowContextSme } from '../../context';
import { getProductTypesFromEnergyType } from '../../helpers';

export type GetOfferEvent = {
  type: 'GET_OFFER';
  flowContext: FlowContextSme;
};

export const getOfferRequestBody = (
  values: FlowContextSme,
): RequestModels_Products_Offers_V3_OfferProductsPublicV3Request => {
  const {
    postalCode,
    houseNumber = 0,
    houseNumberSuffix = '',
    usageElectricityHigh,
    usageElectricityLow,
    solarPanelsOutput = 0,
    usageGas = 0,
    hasResidencePurpose,
    voucherCode,
    isMoving,
    energyType,
    deliveryDate,
  } = values;

  return {
    data: {
      offerType: 'NewEnergyContract',
      address: {
        postalCode: postalCode?.replace(/\s/g, ''),
        houseNumber,
        houseNumberSuffix,
      },
      usages: {
        electricityNormal: usageElectricityHigh,
        electricityLow: usageElectricityLow,
        electricityRedeliveryNormal: solarPanelsOutput,
        electricityRedeliveryLow: 0, // Deprecated
        gas: usageGas,
        warmthElectricity: 0, // Not applicable for SME energy flow
        warmthWater: 0, // Not applicable for SME energy flow
      },
      isResidence: !!hasResidencePurpose,
      voucherCode,
      movingCustomer: !!isMoving,
      products: getProductTypesFromEnergyType(energyType),
      preferredContractStartDate: deliveryDate && formatShortISO(parse(deliveryDate, DATE_FORMAT)),
      isMkb: true,
      urgent: false, // Not applicable for SME energy flow
      includeRentalProducts: false, // Not applicable for SME energy flow
      allowDynamicOrHybridOnly: false, // Not applicable for SME energy flow
    },
  };
};

/**
 * Builds a stable fingerprint of the inputs that determine an offer response. Two events with the
 * same fingerprint produce the same offer, so the cached response can be reused without refetching.
 */
export const getOfferEventHash = ({ flowContext }: GetOfferEvent): string =>
  `offer:${JSON.stringify(getOfferRequestBody(flowContext))}`;
